





























































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import storage from 'baimahu/storage';

const _ = {
  flatMap: require('lodash/flatMap'),
};
const clean = require('bmh/clean-empty-obj');
const { VUE_APP_FCAPI: FCAPI } = process.env;
import {
  TypeEnum as WareType,
  TYPE_LIST as WARE_TYPE_LIST,
  TYPE_MAP as WARE_TYPE_MAP,
} from '@/view/ware/constant';

import { WareSortType, Ware, ConfigWareData, getWare } from './config';

const MAIN_TITLE_MAX_LENGTH = 6;
const SUBTITLE_MAX_LENGTH = 12;
const WARE_PAGINATION_SIZE = 5;
const FILTER_DEFAULT_TYPE = '';

interface WareEditSortPopup {
  id: number;
  visible: boolean;
  value: string | number;
}

interface AddWareModalFilter {
  name: string;
  type: WareType | string;
}

interface AddWareModal {
  visible: boolean;
  filter: AddWareModalFilter;
  loading: boolean;
  data: FcapiRemotePagination<Ware>;
  selected_id_list: number[];
  all_ware_data: {
    [propName: number]: Ware[];
  };
}

function getWareEditSortPopup(
  id?: Ware['id'],
  value?: string | number
): WareEditSortPopup {
  return {
    id: id || 0,
    visible: !!id,
    value: value || '',
  };
}

function getPagingWare(remote?: FcapiRemotePagination<any>) {
  remote = (remote || {}) as FcapiRemotePagination<any>;
  const current = remote.current;
  return {
    current: +current || 1,
    detail: (remote.detail || []).map((remote_ware: any) =>
      getWare(remote_ware, 0)
    ), // 弹窗中选择时更新 sort
    last: remote.last || 1,
    limit: remote.limit || 1,
    total: remote.total || 0,
  };
}

const API = {
  query: `${FCAPI}/shang/ware`,
};

@Component
export default class ActivityConfigSecondWare extends Vue {
  @Prop({ type: Object, default: null }) readonly formItemLayout!: any;
  @Prop({ type: Object }) configWareData!: ConfigWareData;

  main_title: string = this.configWareData.main_title; // optional
  subtitle: string = this.configWareData.subtitle; // optional
  sort_type: WareSortType = this.configWareData.sort_type;
  show_ware_count_in_vertical: number | string = this.configWareData
    .show_ware_count_in_vertical; // required on sort_type === sortSortType.vertical

  ware_list: Ware[] = this.configWareData.ware_list;
  show_ware_list_current_page: number = 1;

  ware_edit_sort_popup: WareEditSortPopup = getWareEditSortPopup();

  add_ware_modal: AddWareModal = {
    visible: false,
    loading: false,
    filter: {
      name: '',
      type: '',
    },
    data: getPagingWare(),
    selected_id_list: [],
    all_ware_data: {},
  };

  get addWareModalFilterDefaultType(): string {
    return FILTER_DEFAULT_TYPE;
  }

  get wareTypeList(): SelectOption[] {
    return WARE_TYPE_LIST;
  }

  get wareData(): Pagination<Ware> {
    const size = WARE_PAGINATION_SIZE;
    const total = this.ware_list.length;
    const current = this.show_ware_list_current_page || 1;
    let last = total / size;
    if (last > ~~last || last === 0) {
      // 不是整数或无数据
      last = ~~last + 1;
    }
    const data = this.ware_list.slice((current - 1) * size, current * size);
    return {
      current,
      data,
      last,
      size,
      total,
    };
  }

  get mainTitleLeftInputLength(): number {
    return MAIN_TITLE_MAX_LENGTH - this.main_title.length;
  }

  get subtitleLeftInputLength(): number {
    return SUBTITLE_MAX_LENGTH - this.subtitle.length;
  }

  get sortType(): object {
    return WareSortType;
  }

  get addWareModalCurrentPageSelectedIdList(): number[] {
    const selected_id_list = this.add_ware_modal.selected_id_list;
    const current_page_ware_data_list = this.add_ware_modal.all_ware_data[
      this.add_ware_modal.data.current
    ];

    const current_page_selected_id_list: number[] = current_page_ware_data_list
      ? current_page_ware_data_list
          .filter(
            (item: Ware) =>
              !!selected_id_list.find((id: number) => id === item.id)
          )
          .map((item: Ware) => item.id)
      : [];

    return current_page_selected_id_list;
  }

  get addWareModalRowSelection(): object {
    return {
      selectedRowKeys: this.addWareModalCurrentPageSelectedIdList,
      onSelect: (
        record: any,
        selected: boolean,
        selectedRows: any,
        nativeEvent: any
      ) => {
        if (selected) {
          this.add_ware_modal.selected_id_list.push(record.id);
        } else {
          const index = this.add_ware_modal.selected_id_list.indexOf(record.id);
          this.add_ware_modal.selected_id_list.splice(index, 1);
        }
      },
      onSelectAll: (selected: boolean, selectedRows: any, changeRows: any) => {
        if (selected) {
          this.add_ware_modal.selected_id_list = [
            ...new Set([
              ...this.add_ware_modal.selected_id_list,
              ...selectedRows.map((item: Ware) => item.id),
            ]),
          ];
        } else {
          this.add_ware_modal.selected_id_list = this.add_ware_modal.selected_id_list.filter(
            (id: number) => !changeRows.find((item: Ware) => item.id === id)
          );
        }
      },
    };
  }

  @Watch('configWareData')
  onConfigWareDataChange() {
    this.main_title = this.configWareData.main_title;
    this.subtitle = this.configWareData.subtitle;
    this.sort_type = this.configWareData.sort_type;
    this.show_ware_count_in_vertical = this.configWareData.show_ware_count_in_vertical;
    this.ware_list = this.configWareData.ware_list;
  }

  @Watch('main_title')
  onMainTitleInput(val: string, old: string) {
    if (this.mainTitleLeftInputLength < 0) {
      this.main_title = old;
    }
    this._onUpdateConfigWareData();
  }

  @Watch('subtitle')
  onSubtitleInput(val: string, old: string) {
    if (this.subtitleLeftInputLength < 0) {
      this.subtitle = old;
    }
    this._onUpdateConfigWareData();
  }

  @Watch('sort_type')
  onSortTypeChange() {
    this._onUpdateConfigWareData();
  }

  @Watch('show_ware_count_in_vertical')
  onShowWareCountInVerticalInput() {
    this._onUpdateConfigWareData();
  }

  @Watch('ware_list')
  onWareListChange(val: any) {
    this._onUpdateConfigWareData();
  }

  _onUpdateConfigWareData() {
    this.$emit('update:configWareData', {
      main_title: this.main_title,
      subtitle: this.subtitle,
      sort_type: this.sort_type,
      show_ware_count_in_vertical: this.show_ware_count_in_vertical,
      ware_list: this.ware_list,
    });
  }

  isWareEditSortPopupShow(popup: WareEditSortPopup, record: Ware) {
    return popup.visible && popup.id === record.id;
  }

  sortWareList() {
    this.ware_list.sort((a: Ware, b: Ware) => a.sort - b.sort);
  }

  paginationOption(data: Pagination<any>) {
    return {
      total: data.total,
      showTotal: (total: number) => `共${total}条，每页${data.size}条`,
      pageSize: data.size,
      current: data.current,
    };
  }

  FcapipaginationOption(data: FcapiRemotePagination<any>) {
    return {
      total: data.total,
      showTotal: (total: number) => `共${total}条，每页${data.limit}条`,
      pageSize: data.limit,
      current: data.current,
    };
  }

  onWareEditSortPopupCancel() {
    this.ware_edit_sort_popup = getWareEditSortPopup();
  }

  onWareEditSortPopupCommit(id: number) {
    const value: string | number = this.ware_edit_sort_popup.value;
    if (!/^[1-9]+\d*$/.test(value.toString())) {
      this.$message.error('排序需为整数值');
      return;
    }
    const ware = this.ware_list.find((item: Ware) => item.id === id);
    if (!ware) {
      this.$message.error('数据错误');
      return;
    }

    ware.sort = +value;
    this.sortWareList();

    this.ware_edit_sort_popup = getWareEditSortPopup();
  }

  onWareEditSortPopupTriggerClick(ware: Ware) {
    this.ware_edit_sort_popup = getWareEditSortPopup(ware.id, ware.sort);
  }

  onWareDataTableChange(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    if (next_page !== this.show_ware_list_current_page) {
      this.show_ware_list_current_page = next_page;
    }
  }

  onRemoveWare(index: number) {
    const ware_index =
      index + (this.show_ware_list_current_page - 1) * WARE_PAGINATION_SIZE;
    this.ware_list.splice(ware_index, 1);
    const { last, current } = this.wareData;
    if (current > last) {
      this.show_ware_list_current_page = last;
    }
  }

  async onAddWareModalDataTableChange(
    pagination: any,
    table_filters: any,
    sorter: any
  ) {
    const next_page = pagination.current;
    await this.fetchAddWareModalWare(next_page);
  }

  onAddWareModalClosed() {
    this.add_ware_modal.data = getPagingWare();
    this.add_ware_modal.selected_id_list = [];
    this.add_ware_modal.all_ware_data = {};
  }

  async onAddWare() {
    this.add_ware_modal.visible = true;
    this.add_ware_modal.selected_id_list = this.ware_list.map(
      (item: Ware) => item.id
    );
    await this.fetchAddWareModalWare();
  }

  async onAddWareModalSearch() {
    await this.fetchAddWareModalWare();
  }

  onAddWareModalClearFilter() {
    this.add_ware_modal.filter = {
      name: '',
      type: '',
    };
  }

  async fetchAddWareModalWare(page: number = 1) {
    const filter = this.add_ware_modal.filter;
    const profile = storage.getItem('profile') || {};
    const merchant_id = profile.merchant_id || '';
    const send_data = {
      name: filter.name,
      type: filter.type,
      current: page,
      status: 1,
      limit: 10,
    };
    clean(send_data);
    this.add_ware_modal.loading = true;
    try {
      const _res = await this.$axios.get(API.query, {
        params: send_data,
      });
      const _data = _res.data;
      if (_data.status !== 200) {
        this.add_ware_modal.data = getPagingWare();
        this.add_ware_modal.all_ware_data = {};
        this.$message.error(_data.message);
      } else {
        this.add_ware_modal.data = getPagingWare(_data.data);
        this.add_ware_modal.all_ware_data[
          this.add_ware_modal.data.current
        ] = this.add_ware_modal.data.detail;
      }
    } catch (e) {
      console.error(e);
    }
    this.add_ware_modal.loading = false;
  }

  onAddWareConfirm() {
    const add_ware_modal_all_ware_list: Ware[] = _.flatMap(
      this.add_ware_modal.all_ware_data,
      (item: Ware) => item
    );
    const selected_id_list = this.add_ware_modal.selected_id_list;
    const selected_ware_list = selected_id_list
      .map((id: number) =>
        add_ware_modal_all_ware_list.find((item: Ware) => item.id === id)
      )
      .filter((item: Ware | undefined) => !!item) as Ware[];
    this.ware_list = selected_ware_list.map((item: Ware, index: number) => {
      item.sort = index + 1;
      return item;
    });
    this.add_ware_modal.visible = false;
  }
}
